// PET_NOVA — comportamiento compartido de las secciones propias (prefijo pn-)
(function () {
  if (window.__pnInit) return;
  window.__pnInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLeashProgress() {
    var fill = document.getElementById('pnLeashFill');
    if (!fill) return;
    var LEN = 2000;
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      fill.style.strokeDashoffset = LEN - LEN * pct;
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReveal() {
    var els = document.querySelectorAll('.pn-reveal');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('pn-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pn-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCatTilt() {
    if (reduceMotion) return;
    document.querySelectorAll('.pn-cat-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'translateY(-8px) rotateX(' + (-y * 10).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initEngrave(root) {
    var tagShape = root.querySelector('.pn-tag-shape');
    var swatches = root.querySelectorAll('.pn-swatch');
    var input = root.querySelector('.pn-engrave-input');
    var out = root.querySelector('.pn-engrave-out');
    if (!tagShape && !input) return;
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('pn-active'); });
        sw.classList.add('pn-active');
        if (tagShape) tagShape.setAttribute('fill', sw.dataset.color);
      });
    });
    if (input && out) {
      input.addEventListener('input', function () {
        out.textContent = input.value.trim().toUpperCase() || out.dataset.default || '';
      });
    }
  }

  function initCompare(root) {
    var box = root.querySelector('.pn-compare-box');
    var clip = root.querySelector('.pn-compare-clip');
    var handle = root.querySelector('.pn-compare-handle');
    if (!box || !clip || !handle) return;

    var dragging = false;
    var boxRect = null; // cacheado al iniciar el arrastre; evita reflow en cada movimiento
    var pendingPct = null;
    var rafId = null;

    var paint = function () {
      rafId = null;
      if (pendingPct === null) return;
      var pct = pendingPct;
      clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    };

    var queueCompare = function (clientX) {
      if (!boxRect) return;
      var pct = ((clientX - boxRect.left) / boxRect.width) * 100;
      pendingPct = Math.max(4, Math.min(96, pct));
      if (rafId === null) rafId = requestAnimationFrame(paint);
    };

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      boxRect = box.getBoundingClientRect();
      handle.setPointerCapture(e.pointerId);
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
      boxRect = null;
    });
    window.addEventListener('pointermove', function (e) {
      if (dragging) queueCompare(e.clientX);
    });
    box.addEventListener('click', function (e) {
      if (e.target.closest('.pn-compare-handle')) return;
      boxRect = box.getBoundingClientRect();
      queueCompare(e.clientX);
      boxRect = null;
    });
  }

  function initProductCarousel(root) {
    var track = root.querySelector('[data-pn-carousel]');
    var prev = root.querySelector('[data-pn-carousel-prev]');
    var next = root.querySelector('[data-pn-carousel-next]');
    if (!track) return;
    var scrollByAmount = function () {
      var card = track.querySelector('.pn-prod-card');
      return card ? card.getBoundingClientRect().width + 18 : 300;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLeashProgress();
    initReveal();
    initCatTilt();
    document.querySelectorAll('[data-pn-spotlight]').forEach(initEngrave);
    document.querySelectorAll('[data-pn-compare]').forEach(initCompare);
    document.querySelectorAll('.pn-products').forEach(initProductCarousel);
  });
})();
